
import React, { useRef, forwardRef, useState } from 'react';
import {
  Card, TextField, Grid, Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
} from '@mui/material';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';


import { DatePicker,MobileDatePicker,LocalizationProvider } from '@mui/x-date-pickers';


import {getDateINYMD} from '../../../utils/formatTime'


/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */


export default function DateRangePickerDialog({ openDateRangeModal, handleClose,actionData, onAction }) {

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };


  return (
    <Dialog
      open={openDateRangeModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="date-range-dialog-slide-description"
      data-testid="date-range-picker-dialog"  // ✅ Added test ID
      
    >
      <DialogTitle>Select Date range</DialogTitle>
      <DialogContent>
        <DialogContentText id="date-range-dialog-slide-description">

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={3} direction={{xs: 'column', sm:'row', md:'row'}}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" sx={{mb:1}}>Start Date </Typography>

             

                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={startDate}
                  onChange={handleStartDateChange}
                  maxDate={new Date()}
                  renderInput={(params) => (
                    <TextField {...params} inputProps={{ ...params.inputProps, 'data-testid': 'start-date' }} />
                  )}                  
                  format="DD-MM-YYYY"
                 
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1" sx={{mb:1}}>End Date </Typography>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={endDate}
                  maxDate={new Date()}
                  minDate={startDate}
                  onChange={handleEndDateChange}
                  renderInput={(params) => (
                    <TextField {...params} inputProps={{ ...params.inputProps, 'data-testid': 'end-date' }} />
                  )}                 
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

        </DialogContentText>
      </DialogContent>
      <DialogActions>

        <Button data-testid='date-range-ok-button' onClick={()=>{onAction(startDate,endDate,actionData);handleClose() }}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

